/**
 * We need to have all these configuration variables defined. Previously, they were built in to the
 * javascript bundle, but to make deployment easier, we now put them in a public env.js file that
 * needs to be loaded before the main bundle.
 *
 * During dev, this is handled by setupProxy.js as a nodejs express route
 * For a production build, the env.js file is served using a nginx route
 */
const defaultEnv =
    import.meta.env.MODE === 'test'
        ? {
              DATOCMS_TOKEN: process.env.VITE_DATOCMS_TOKEN,
              DATOCMS_URL: process.env.VITE_DATOCMS_URL,
              BINOSIGHT_API_URL: process.env.BINOSIGHT_API_URL,
          }
        : {};

export default ((window as any).env ?? defaultEnv) as {
    BINOSIGHT_API_URL: string; // This is now just a path, like /api-prod, since we proxy these requests
    CLIENT_ID: string; // For the logic service
    LOGIN_URL: string;
    ANSWER_SURVEY_URL: string;
    DATOCMS_TOKEN: string;
    DATOCMS_URL: string;
    GOOGLE_MAPS_API_KEY: string;
    HEREWEGO_MAPS_API_KEY: string;
};
